import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone : false
})
export class LoginComponent {
  loginForm!: FormGroup; // Use definite assignment assertion
  error = '';

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router) {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home']);
      return;
    }
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  login() {
    this.error = '';
    if (this.loginForm.valid) {
        const { email, password } = this.loginForm.value;
        this.authService.login(email, password).subscribe({
            next: () => {
              this.router.navigate(['/home']);
              // Trigger any auth state change here if needed
            },
            error: (err) => {
                console.error('Login error:', err);
                this.error = 'Invalid email or password.';
            }
        });
    }
  }
}
